import { DocumentData } from "firebase/firestore";
import { createContext } from "react";

export interface UserFavorite {
  favoritedAt: Date;
}

export interface UserFavorites extends DocumentData {
  [campgroundId: string]: UserFavorite;
}

export interface UserDocument extends DocumentData {
  email?: string;
  displayName?: string;
  lastUpdated?: Date;
  /**
   * Written by the admin tooling, read here only to decide what to SHOW.
   *
   * Not a security boundary: this is a Firestore document the client reads
   * itself, so anything gated on it must also be enforced server-side. The
   * 12-hour drive time is, in the search route; the map debug menu is not,
   * because it only surfaces coordinates the user could read off the URL.
   */
  is_admin?: boolean;
}

export interface UserContextValue {
  // User document
  user: UserDocument | null;

  /** Convenience for `user?.is_admin === true`. Controls UI affordances only. */
  isAdmin: boolean;

  // Favorites
  favorites: UserFavorites;
  addFavorite: (campgroundId: string) => Promise<void>;
  removeFavorite: (campgroundId: string) => Promise<void>;
  isFavorite: (campgroundId: string) => boolean;

  // Last search
}

export const UserContext = createContext<UserContextValue | undefined>(
  undefined
);
